module.exports = __webpack_public_path__ + "static/media/chevron-right-solid.f6a12ad2.svg";